// @flow
import GridFooterCellRenderer from './GridFooterCellRenderer';

export default GridFooterCellRenderer;
